<template>
  <el-dialog
    class="line-link-success-dialog"
    :visible.sync="visibleDialog"
    width="335px"
    :close-on-click-modal="false"
    destroy-on-close
    append-to-body
  >
    <p>{{ $t('lineLink.content.linkSuccessMessage1') }}</p>
    <p class="mb-8">{{ $t('lineLink.content.linkSuccessMessage2') }}</p>

    <div class="text-center">
      <el-button class="w-full" type="primary" @click="onDetail">{{ $t('common.action.ok') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { ENV_KEY } from '@/constants/env'
export default {
  name: 'LineNotifyShoppingDialog',

  props: {
    visible: Boolean,
  },

  computed: {
    visibleDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },

  methods: {
    onDetail() {
      const linkElement = document.createElement('a')
      linkElement.setAttribute(
        'href',
        `https://line.me/R/ti/p/~${this.$store.getters['env/GET_KEY'](ENV_KEY.LINE_BOT_ID)}`
      )
      linkElement.click()
    },
  },
}
</script>
